import { render, staticRenderFns } from "./CreditCardDebt.vue?vue&type=template&id=6ee38326&scoped=true&"
import script from "./CreditCardDebt.vue?vue&type=script&lang=js&"
export * from "./CreditCardDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee38326",
  null
  
)

export default component.exports